// Database işlemeleri yapılacak ve dönen datanın state e geçmesi için mutation a gönderilecek
import sendReq from '@/utils/request'

export const getNewAccountNumber = async ({ commit }, data) => {

    let res;
    res = await sendReq("get","customers/"+data+"/accountno", data)
    commit('getAccountNo', res.data);
}

export const getAccountDetail = async ({ commit }, data) => {
    commit('accountLoading', true);
    commit('accountStatusNull')
    let res;
    res = await sendReq("get","accounts/"+data.id, data)
    commit('getAccountDetail', res.data);
    commit('accountLoading', false);
}

export const createAccount = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("post","customers/"+data.customerId+"/accounts", data)
    commit('accountInfo', res);
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const zone_get = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("get","/accounts/"+data.parent_id+"/zones")
    commit('accountZones', res.data);
    commit('accountLoading', false);
}

export const zone_add = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("post","/accounts/"+data.parent_id+"/zones", data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const zone_edit = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("put","/accounts/"+data.parent_id+"/zones/"+data.id, data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const zone_delete = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("delete","/accounts/"+data.parent_id+"/zones/"+data.id)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const paneluser_get = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("get","/accounts/"+data.parent_id+"/users?type="+data.type)
    commit('accountUser', res.data);
    commit('accountLoading', false);
}

export const paneluserldap_get = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("get","/accounts/"+data.parent_id+"/users?type="+data.type)
    commit('accountUser', res.data);
    commit('accountLoading', false);
}

export const account_user_list = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("get","/accounts/"+data.parent_id+"/users?type="+data.type)
    commit('accountUser', res.data);
    commit('accountLoading', false);
 }

export const paneluser_add = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("post","/accounts/"+data.parent_id+"/users", data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}
export const alarmuser_copy = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("post","/accounts/"+data.parent_id+"/users/"+data.user_id+'/copy', data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}
export const paneluser_edit = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("put","/accounts/"+data.parent_id+"/users/"+data.id, data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const paneluser_delete = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("delete","/accounts/"+data.parent_id+"/users/"+data.id)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const paneluserldap_add = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("post","/accounts/"+data.parent_id+"/users/ldap", data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const paneluserldap_edit = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("put","/accounts/"+data.parent_id+"/users/"+data.id, data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const paneluserldap_delete = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("delete","/accounts/"+data.parent_id+"/users/"+data.id)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const exceptions_get = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("get","/accounts/"+data.parent_id+"/alertdefs")
    commit('accountAlertDefs', res.data);
    commit('accountLoading', false);
}

export const exceptions_add = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("post","/accounts/"+data.parent_id+"/alertdefs", data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const exceptions_edit = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("put","/accounts/"+data.parent_id+"/alertdefs/"+data.id, data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const exceptions_delete = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("delete","/accounts/"+data.parent_id+"/alertdefs/"+data.id)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const getAccountAlertDef = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("get","/accounts/"+data.accountId+"/alertsignaldefs")
    commit('accountSignalDefs', res.data);
    commit('accountLoading', false);
}

export const note_get = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("get","/accounts/"+data.parent_id+"/notes")
    commit('accountNotes', res.data);
    commit('accountLoading', false);
}

export const note_add = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("post","/accounts/"+data.parent_id+"/notes", data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const note_edit = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("put","/accounts/"+data.parent_id+"/notes/"+data.id, data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const note_delete = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("delete","/accounts/"+data.parent_id+"/notes/"+data.id)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const notification_get = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("get","/accounts/"+data.parent_id+"/notifications")
    console.log(res.data)
    commit('accountNotifications', res.data);
    commit('accountLoading', false);
}

export const notification_add = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("post","/accounts/"+data.parent_id+"/notifications", data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const notification_edit = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("put","/accounts/"+data.parent_id+"/notifications/"+data.id, data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const notification_delete = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("delete","/accounts/"+data.parent_id+"/notifications/"+data.id)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const workhours_get = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("get","/accounts/"+data.parent_id+"/hours")
    commit('accountHours', res.data);
    commit('accountLoading', false);
}

export const workhours_add = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("post","/accounts/"+data.parent_id+"/hours", data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const workhours_edit = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("put","/accounts/"+data.parent_id+"/hours/"+data.id, data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const workhours_delete = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("delete","/accounts/"+data.parent_id+"/hours/"+data.id)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const getTracings = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("get","/accounts/"+data.accountId+"/tracings")
    commit('accountTracings', res.data);
    commit('accountLoading', false);
}

export const updateTracings = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("put","/accounts/"+data.accountId+"/tracings/"+data.id, data)
    commit('accountLoading', false);
}

export const account_get = async ({ commit }, data) => {
    commit('accountLoading', true);
    commit('accountStatusNull')
    let res;
    res = await sendReq("get","accounts", data)
    commit('accounts', res.data);
    commit('accountLoading', false);
}

export const communications_get = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("get","/accounts/"+data.parent_id+"/coms")
    commit('accountComs', res.data);
    commit('accountLoading', false);
}

export const communications_add = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("post","/accounts/"+data.parent_id+"/coms", data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const communications_edit = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("put","/accounts/"+data.parent_id+"/coms/"+data.id, data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const communications_delete = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("delete","/accounts/"+data.parent_id+"/coms/"+data.id)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const account_state = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("put","/accounts/"+data.id+"/state", data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const account_copy = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("post","/accounts/"+data.id+"/copy-account", data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const account_part = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("post","/accounts/"+data.id+"/copy-part", data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const getAccountAddress= async ({ commit }, data) => {
    //commit('accountLoading', true);
    let res;
    res = await sendReq("get","/accounts/"+data+"/address")
    commit('accountAddress', res.data);
    //commit('accountLoading', false);
}

export const account_delete = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("delete","/accounts/"+data.id)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}
export const vacation_get = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("get","/accounts/"+data.parent_id+"/vacations")
    commit('accountVacations', res.data);
    commit('accountLoading', false);
}

export const vacation_add = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("post","/accounts/"+data.parent_id+"/vacations", data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const vacation_edit = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("put","/accounts/"+data.parent_id+"/vacations/"+data.id, data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const vacation_delete = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("delete","/accounts/"+data.parent_id+"/vacations/"+data.id)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const account_edit = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("put","/accounts/"+data.id, data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const copyWorkHour = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("post","/accounts/"+data.accountId+'/hours/'+data.id+'/copy', data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const workhourstolerance_tolerance = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("put","/accounts/"+data.parent_id+'/hours/set-tolerance', data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const workhourstolerance_get = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("get","/accounts/"+data.parent_id+"/hours")
    commit('accountHours', res.data);
    commit('accountLoading', false);
}

export const cameras_get = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("get","/accounts/"+data.parent_id+'/cameras', data)
    commit('getAccountCameras', res);
    commit('accountLoading', false);
}

export const cameras_add = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("post","/accounts/"+data.parent_id+'/cameras', data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const devices_get = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("get","/accounts/"+data.parent_id+'/devices')
    commit('getAccountDevices', res);
    commit('accountLoading', false);
}

export const devices_add = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("post","/accounts/"+data.parent_id+'/devices', data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const devices_edit = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("put","/accounts/"+data.parent_id+'/devices/'+data.id, data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const devices_delete = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("delete","/accounts/"+data.parent_id+'/devices/'+data.id, data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}

export const sendCommandDevice = async ({ commit }, data) => {
    commit('accountLoading', true);
    let res;
    res = await sendReq("post","/prosec-panel/"+data.id+'/control-panel', data)
    commit('setAccountStatus', res);
    commit('accountLoading', false);
}



// WEBPACK FOOTER //
// ./src/store/modules/Alarmsis/Account/Actions.js